import React from "react"

import { BATCH_ROUTES, FEATURES_TYPE } from "@constants"
import AppLayout from "Layout"
import BatchPage from "./Page"


export const BatchRoutes = userData => ({
	id: FEATURES_TYPE.BATCH,
	path: BATCH_ROUTES.PATH,
	title: BATCH_ROUTES.TITLE,
	icon: 'clipboard-list',
	element: <AppLayout/>,
	children: [{ element: <BatchPage/>, index: true }]
})